<svg viewBox="0 0 100 100" class="w-full -rotate-90">
  <circle
    stroke="var(--color-interface-surface-300)"
    [attr.stroke-width]="strokeWidth + '%'"
    cx="50"
    cy="50"
    r="30"
    fill="none"
    pathLength="100"
  />
  <circle
    stroke="var(--color-text-common-primary)"
    [attr.stroke-width]="strokeWidth + '%'"
    stroke-dasharray="100"
    stroke-linecap="round"
    [attr.stroke-dashoffset]="completedPercentage()"
    cx="50"
    cy="50"
    r="30"
    fill="none"
    pathLength="100"
  />
</svg>
